<span
  class="position--relative sort-button"
  style="cursor: pointer"
  (click)="handleClick()"
  (mouseenter)="hovered = true"
  (mouseleave)="hovered = false"
>
  <span
    class="up"
    [ngClass]="{
			hovered: hovered && !upSelected,
			selected: upSelected
		}"
  >
    <ta-icon icon="up"></ta-icon>
  </span>
  <span
    class="down"
    [ngClass]="{
			hovered: hovered && !downSelected,
			selected: downSelected
		}"
  >
    <ta-icon icon="down"></ta-icon>
  </span>
</span>
